var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconBookingConfirmed = function SvgIconBookingConfirmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 100
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-5H95v110H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.448 60.849c-6.48 4.472-14.693 5.493-22.562 5.919-5.375.29-11.047.348-16.173-1.292-2.603-.832-4.563-2.176-7.342-3.96v23.596c0 4.9 4.538 8.68 9.453 8.68h68.2c2.975 0 4.79-2.211 4.79-5.177V15.3c0-.696.041-1.366-.142-1.994-7.124 5.706-12.901 12.914-17.005 21.057-5.761 11.431-8.67 19.205-19.219 26.486z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#001E62",
    strokeLinecap: "square",
    strokeWidth: 2.5,
    d: "M1.926 18.12v66.992c0 4.9 3.983 8.874 8.897 8.874h68.201c2.975 0 5.386-2.405 5.386-5.371V15.3c0-3.612-2.936-6.541-6.56-6.541H4.938a2.84 2.84 0 0 1-2.844-2.837c0-2.015 1.544-3.648 3.449-3.648 1.905 0 3.45 1.633 3.45 3.648v5.167c0 2.015 1.543 3.649 3.449 3.649h.6c2.017 0 3.652-1.729 3.652-3.862V6.105c0-2.182 1.672-3.952 3.735-3.952h.173c2.062 0 3.734 1.77 3.734 3.952v4.771c0 2.133 1.636 3.862 3.652 3.862 2.017 0 3.652-1.729 3.652-3.862V6.105c0-2.182 1.672-3.952 3.735-3.952 2.062 0 3.735 1.77 3.735 3.952v4.771c0 2.133 1.634 3.862 3.651 3.862h.393c2.017 0 3.652-1.729 3.652-3.862V6.105c0-2.182 1.672-3.952 3.734-3.952 2.064 0 3.736 1.77 3.736 3.952v4.771c0 2.133 1.634 3.862 3.652 3.862 2.016 0 3.651-1.729 3.651-3.862V6.105c0-2.182 1.672-3.952 3.735-3.952 2.063 0 3.735 1.77 3.735 3.952v4.771c0 2.133 1.635 3.862 3.652 3.862h.393c2.016 0 3.652-1.729 3.652-3.862V6.105c0-2.182 1.672-3.952 3.734-3.952h.503"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#001E62",
    strokeLinecap: "square",
    strokeWidth: 2.5,
    d: "M13.818 98.345h65.808c4.802 0 8.694-3.883 8.694-8.671V19.659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.856 41.365H21.432M68.7 55.163H41.722m31.505 14.275H54.018M48.55 29.714v11.974m0 28.828v11.973m13.02-50.897v51.233M33.884 29.714v16.277m0 30.512v7.21M21.073 33.99v7.375M10.572 27.296l64.568.256v56.194H24.7",
    stroke: "#001E62",
    strokeLinecap: "square",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C39",
    d: "m23.063 55.126 15.464 15.5 28.996-29.062-6.766-6.78L38.41 57.182l-8.699-8.718z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#001E62",
    strokeLinecap: "square",
    strokeWidth: 2.5,
    d: "m23.063 55.126 15.464 15.5 28.996-29.062-6.766-6.78L38.41 57.182l-8.699-8.718z"
  }))));
};

export default SvgIconBookingConfirmed;